import _slicedToArray from "/Users/n8/Development/EtherGrass V2/code/.build/websites/ethergrass.io/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useReducer } from 'react';
import { BlockNumberContext } from './context';
import { blockNumberReducer } from './reducer';
import { useEthers, useDebounce } from '../../hooks';
export function BlockNumberProvider(_ref) {
  var children = _ref.children;

  var _useEthers = useEthers(),
      library = _useEthers.library,
      chainId = _useEthers.chainId;

  var _useReducer = useReducer(blockNumberReducer, {}),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  useEffect(function () {
    if (library && chainId !== undefined) {
      var update = function update(blockNumber) {
        return dispatch({
          chainId: chainId,
          blockNumber: blockNumber
        });
      };

      library.on('block', update);
      return function () {
        library.off('block', update);
      };
    }
  }, [library, chainId]);
  var debouncedState = useDebounce(state, 100);
  var blockNumber = chainId !== undefined ? debouncedState[chainId] : undefined;
  return _jsx(BlockNumberContext.Provider, {
    value: blockNumber,
    children: children
  }, void 0);
}